import { render, staticRenderFns } from "./SurveyData.vue?vue&type=template&id=493f7d33&"
import script from "./SurveyData.vue?vue&type=script&lang=js&"
export * from "./SurveyData.vue?vue&type=script&lang=js&"
import style0 from "./SurveyData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports